import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-[#faf9f7] py-10 md:py-16 px-4" data-id="element-279">
      <div className="max-w-3xl mx-auto" data-id="element-280">
        <div className="bg-white p-6 md:p-12 rounded-2xl border-l-4 border-[#e53935] shadow-lg" data-id="element-281">
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-2 leading-tight" data-id="element-282">
            Muchos quieren aprender barbería.
          </h2>
          <p className="text-xl md:text-3xl font-black text-[#e53935] mb-6 leading-tight" data-id="element-283">
            Pero pocos lo hacen con método.
          </p>
          <div className="w-12 h-0.5 bg-gradient-to-r from-[#e53935] to-[#ff7043] mb-6" data-id="element-284"></div>

          <div className="space-y-4" data-id="element-285">
            <p className="text-base md:text-lg text-gray-600 leading-relaxed" data-id="element-286">
              La mayoría intenta aprender viendo videos sueltos o copiando lo
              que ve en redes.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed font-semibold" data-id="element-287">
              El problema es que sin estructura, el progreso se vuelve lento y
              confuso.
            </p>
            <p className="text-base md:text-lg text-gray-900 leading-relaxed font-black mt-6" data-id="element-288">
              Método Barber Pro fue creado para resolver eso.
            </p>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed" data-id="element-289">
              Una formación clara, organizada y pensada para que desarrolles
              técnica real paso a paso.
            </p>
          </div>
        </div>
      </div>
    </section>;
}